import Config from '@/config'

const attrArr = JSON.stringify(Config.Theme.attributesToload)

/**
 * searchGraph = filter: {
            color: {eq: "5477"},
            size: {eq: "5593"},
            category_id: {in: ["11","12","13","14","15","16","17","18","19"]}
        },
        currentPage: 1,
        pageSize: 9,
        sort: { position: DESC }
 */
const environmentFieldGeneral = `
  model_sku
  sibling_products {
    url_key
    url_suffix
    color
    color_label
    color_image
  }
`

/* const environmentFieldConfigurable = `
  translations(attribute_code: "size"){
    label
    zone
  }
` */

export default `query Products(
      $search: String
      $currentPage: Int
      $filter: ProductAttributeFilterInput
      $pageSize: Int
      $sort: ProductAttributeSortInput,
      $id: Int
    ) {
    category (id: $id) {
      name
      display_mode
      cms_block{
        title
        identifier
      }
      breadcrumbs{
        category_id
        category_url_path
        category_url_key
        category_level
        category_id
        category_name
      }
      canonical_url
      custom_canonical_link
      href_lang_links{href, hreflang}
      description_with_crosslink
      meta_description
      meta_title
      meta_keywords
      meta_robots
      head_content_page
    }
    products(
      search: $search
      currentPage: $currentPage
      filter: $filter
      pageSize: $pageSize
      sort: $sort ) {
      items {
        id
        sku
        name
        size
        stock_status
        canonical_url
        url_suffix
        url_key
        color
        color_label
        color_image
        ${process.env.VUE_APP_ORIGIN === 'ONLINE' ? environmentFieldGeneral : ''}
        categories{
          breadcrumbs{
            category_name
            category_url_path
          }          
        }
        tax_rate
        new_from_date
        new_to_date
        is_exclusive_online
        attributesLabel (attributes_identifier: ${attrArr}) {
          label
          value
          attribute_id
          attribute_code
        }
        description { html }
        short_description { html }
        price_range {
          minimum_price {
            discount {
              amount_off
              percent_off
            }
            regular_price {
              value
              currency
            }
            final_price {
              value
              currency
            }
          }
          maximum_price {
            discount {
              amount_off
              percent_off
            }
            regular_price {
              value
              currency
            }
            final_price {
              value
              currency
            }
          }
        }
        price_tiers {
          discount {
            amount_off
            percent_off
          }
          final_price {
            currency
            value
          }
          quantity
        }
        special_price
        special_from_date
        special_to_date
        image{
          label
          url
        }
        media_gallery{
          position
          disabled
          label
          url
          ...on ProductVideo {
            position
            video_content {
              media_type
              video_provider
              video_url
              video_title
              video_description
              video_metadata
            }
          }
        }
        ... on ConfigurableProduct {
          configurable_options {
            id
            label
            attribute_code
            attribute_id
            values {
              value_index
              label
              default_label
              store_label
            }
          }
          variants {
            product {
              id
              sku
              stock_status

              name
              quantity
              price_tiers {
                final_price {
                  value
                }
                discount {
                  amount_off
                  percent_off
                }
              }
              special_price
              price_range {
                minimum_price {
                  discount {
                    amount_off
                    percent_off
                  }
                  regular_price {
                    value
                    currency
                  }
                  final_price {
                    value
                    currency
                  }
                }
                maximum_price {
                  discount {
                    amount_off
                    percent_off
                  }
                  regular_price {
                    value
                    currency
                  }
                  final_price {
                    value
                    currency
                  }
                }
              }
              media_gallery{
                label
                url
                position
              }
              image {
                url
                label
              }
            }
            attributes {
              label
              code
              value_index
            }
          }
        }
      }
      total_count
      aggregations {
        attribute_code
        count
        label
        options {
          count
          label
          value
        }
      }
      aggregationsStore {
        attribute_code
        count
        label
        options {
          count
          label
          value
        }
      }
      sort_fields{
        default
        options{
          label,
          value
        }
      }
    }
  }`
